<template>
  <div class="main__container">
    <div class="content">
      <div class="tit">{{ detail.title }}</div>
      <div class="info">
        <div class="date">日期：{{ detail.createTime }}</div>
        <div class="name">撰稿人：{{ detail.createBy }}</div>
      </div>
      <div class="html">
        <div>{{ detail.content }}</div>
        <img :src="detail.cover" alt="" style="width: 100%;" />
      </div>
    </div>
    <div class="fixed">
      <div class="item" @click="scrollToTop()">
        <img src="../assets/home/icon_img27.png" alt="" />
      </div>
      <div class="item copy" style="border: 0" @click="copyText">
        <img src="../assets/home/icon_img28.png" alt="" />
      </div>
    </div>
    <div class="bom">
      <div class="bom_t">
        其他推荐
      </div>
      <div class="bom_c">
        <div
          class="item"
          v-for="(item, index) in recommendList"
          :key="index"
          @click="goDetail(item.id)"
        >
          <img :src="item.cover" alt="" />
          <div class="ri">
            <div class="tit">
              {{ item.title }}
            </div>
            <div class="txt">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInformationDetail, getOtherRecommend } from "@/api";

export default {
  name: "InformationDetail",
  data() {
    return {
      detail: {},
      recommendList: [],
    };
  },
  created() {
    this.getInformationDetail();
    this.getOtherRecommend();
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/information-detail?id=${id}`);
    },
    async getInformationDetail() {
      const { data } = await getInformationDetail(this.$route.query.id);
      this.detail = data.data;
    },
    async getOtherRecommend() {
      const { data } = await getOtherRecommend({
        id: this.$route.query.id,
        pageNum: 1,
        pageSize: 4,
      });
      this.recommendList = data.data;
    },
    copyText() {
      const pageUrl = window.location.href;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(pageUrl)
          .then(() => {
            this.$message.success("链接已复制到剪贴板！");
          })
          .catch((err) => {
            console.error("复制失败：", err);
            this.$message.error("复制失败，请手动复制！");
          });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = pageUrl;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();

        try {
          const successful = document.execCommand("copy");
          if (successful) {
            this.$message.success("链接已复制到剪贴板！");
          } else {
            this.$message.error("复制失败，请手动复制！");
          }
        } catch (err) {
          console.error("复制失败：", err);
          this.$message.error("复制失败，请手动复制！");
        }

        document.body.removeChild(textArea);
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 可选参数，用于平滑滚动
      });
    },
  },
};
</script>

<style scoped lang="less">
.main__container {
  background-color: #eef0f3;
  padding-top: 72px;
  overflow: hidden;
  .content {
    width: 1150px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.02);
    background-color: #fff;
    margin: 38px auto 100px;
    padding: 40px 52px;
    .tit {
      font-weight: 600;
      font-size: 30px;
      color: rgba(0, 0, 0, 0.85);
    }
    .info {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 16px;
      margin-bottom: 40px;
      .name {
        margin-left: 36px;
      }
    }
  }
  .fixed {
    position: fixed;
    z-index: 99;
    right: 100px;
    top: 50%;
    width: 35px;
    height: 78px;
    border-radius: 18px;
    border: 1px solid #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      width: 35px;
      img {
        width: 18px;
        height: 18px;
      }
    }
  }
  .bom {
    margin: 0 auto 100px;
    width: 1150px;
    .bom_t {
      font-weight: 500;
      font-size: 24px;
      color: rgba(0, 0, 0, 0.85);
    }
    .bom_c {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        margin-top: 36px;
        display: flex;
        width: 558px;
        cursor: pointer;
        img {
          width: 248px;
          height: 128px;
          object-fit: cover;
          margin-right: 16px;
        }
        .ri {
          flex: 1;
          .tit {
            height: 52px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            display: -webkit-box;
            -webkit-line-clamp: 2; /* 设置显示的行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .txt {
            margin-top: 14px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            display: -webkit-box;
            -webkit-line-clamp: 3; /* 设置显示的行数 */
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
